export enum HomeCountryEnums{
    USA = 207,
    CAN = 197
}

export enum OperatingCountryEnums{
    USA = 57,
    SWE = 52
}

export enum BeneluxCountries {
    BEL = 'BEL',
    NLD = 'NLD',
    LUX = 'LUX'
}

export enum MergeredCountries {
    FRA = 'FRA',
    ESP = 'ESP',
    PRT = 'PRT'
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/countries.enums.ts